<div class="cita-container">
    <h2>Cita Médica</h2>
    <div class="info">
        <!-- Área -->
        <div class="info-item" *ngIf="agendamiento && agendamiento.area !== 'N/A'">
            <span class="check">✔</span>
            <div>
                <p class="label">Área</p>
                <p class="value">Telemedicina</p>
            </div>
        </div>

        <!-- Especialidad / Exámen -->
        <div class="info-item" *ngIf="agendamiento?.especialidadmedico !== 'N/A' && agendamiento?.especialidadmedico">
            <span class="check">✔</span>
            <div>
                <p class="label">Especialidad / Exámen</p>
                <p class="value">{{ agendamiento?.especialidadmedico }}</p>
            </div>
        </div>

        <!-- Subespecialidad: Se oculta si está vacío o es "N/A" -->
        <div class="info-item" *ngIf="agendamiento?.subespecialidad !== 'N/A' && agendamiento?.subespecialidad">
            <span class="check">✔</span>
            <div>
                <p class="label">Subespecialidad</p>
                <p class="value">{{ agendamiento?.subespecialidad }}</p>
            </div>
        </div>

        <!-- Centro: Se oculta si está vacío o es "N/A" -->
        <div class="info-item" *ngIf="agendamiento?.centro !== 'N/A' && agendamiento?.centro">
            <span class="check">✔</span>
            <div>
                <p class="label">Centro</p>
                <p class="value">{{ agendamiento?.centro }}</p>
            </div>
        </div>

        <div class="info-item" *ngIf="agendamiento?.nombremedico !== 'N/A' && agendamiento?.nombremedico">
            <span class="check">✔</span>
            <div>
                <p class="label">Especialista</p>
                <p class="value">{{ agendamiento?.nombremedico }}</p>
            </div>
        </div>

        <!-- Monto a Pagar -->
        <div class="info-item" *ngIf="valorPagar !== null && valorPagar !== undefined">
            <span class="check">✔</span>
            <div>
                <p class="label">Monto a Pagar</p>
                <p class="value">{{ valorPagar }}</p>
            </div>
        </div>
    </div>

    <div class="footer-container">
        <div class="date-warning-container">
            <div class="date-time-box">
                <div class="date">Día: <strong>{{ agendamiento?.fechacita_local }}</strong></div>
                <div class="time">Hora: <strong>{{ agendamiento?.horacita_local }}</strong></div>
            </div>
            <p class="warning">Tienes <strong>20 minutos</strong> para pagar la cita o será <strong>CANCELADA</strong>.</p>
        </div>
        
        <div class="actions" (click)="closeModal()">
            <div class="action-item">
                <i class="fas fa-trash-alt"></i>
                <p>Cancelar</p>
            </div>
            <!-- <div class="action-item" (click)="confirmarPago()"> -->
                <div class="action-item">
                <i class="fas fa-check-circle"></i>
                <p>Confirmar/pagar</p>
            </div>              
        </div>
    </div>
</div>
<app-spinner></app-spinner> 